import { Id } from '@/infra/id'
import { Model, type ModelProps } from '@/infra/model'
import { unixEpoch } from '@/utils/date-util'
import { observable } from 'mobx'

export type RoomSessionProps = ModelProps<RoomSession>

/**
 * A call held in a room.
 */
export class RoomSession extends Model<RoomSession> {
  id = Id.none

  @observable accessor dateStarted = unixEpoch()
  @observable accessor dateModified = unixEpoch()
  @observable accessor status: RoomSessionStatus = 'Unknown'
}

/**
 * Whether a call is in progress.
 */
export type RoomSessionStatus = 'Unknown' | 'Active' | 'Ended'
